<template>
  <div id="scientific">
    <el-container>
      <el-aside width="23%">
        <div class="catalog">
          <h5 style="font-size: 20px; text-align: center" class="catalog-title">科研成果</h5>
          <el-menu
            :default-active="activeIndex"
            :default-openeds="openeds"
            :router="true"
          >
            <el-submenu index="1">
              <!-- <el-submenu> -->
              <template slot="title">
                <!-- <i class="el-icon-s-marketing"></i> -->
                <span style="font-weight: bolder; color: #076498">平台系统</span>
              </template>
              <!-- <el-submenu index="1-1"> -->
              <!-- <el-submenu> -->
              <!-- <template slot="title">遥感典型地理要素提取与更新系统</template> -->
              <el-menu-item
                @click="saveNavState('/scientific/UAV_system')"
                index="/scientific/UAV_system"
              >
                <span slot="title">自主研制轻小型无人机机巢</span>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/UAV_auto')"
                index="/scientific/UAV_auto"
              >
                <span slot="title">通导遥一体的无人机远程全自主感知系统</span>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/LuojiaSwarm')"
                index="/scientific/LuojiaSwarm"
              >
                <span slot="title">无人机集群全自动测图系统 LuojiaSwarm</span>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/Target_retrieval')"
                index="/scientific/Target_retrieval"
              >
                <span slot="title">大规模遥感图像智能检索系统</span>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/Element_extraction')"
                index="/scientific/Element_extraction"
              >
                <span slot="title">遥感典型地理要素提取与更新系统</span>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/RS_changeDetection')"
                index="/scientific/RS_changeDetection"
              >
                <span slot="title">遥感影像变化检测系统</span>
              </el-menu-item>

              <!-- <el-menu-item index="1-1-3">灾情提取系统</el-menu-item> -->
              <el-menu-item
                @click="saveNavState('/scientific/UAV')"
                index="/scientific/UAV"
              >
                <span slot="title">无人机遥感在线实时处理系统</span>
              </el-menu-item>
              <!-- <el-menu-item index="1-1-4">深度学习云平台</el-menu-item> -->
              <!-- </el-submenu>
              <el-submenu index="1-2"> -->
              <!-- <template slot="title">变化提取与更新</template> -->
              <el-menu-item
                @click="saveNavState('/scientific/Field_portable_system')"
                index="/scientific/Field_portable_system"
              >
                <span slot="title">便携式地面遥感影像快速处理系统</span>
              </el-menu-item>
              <!-- <el-menu-item index="1-2-1"
                  >典型要素变化检测与更新系统</el-menu-item
                > -->
              <el-menu-item
                @click="saveNavState('/scientific/Onboard_system')"
                index="/scientific/Onboard_system"
              >
                <span slot="title">星载在轨智能处理系统</span>
              </el-menu-item>
              <!-- <el-menu-item index="1-2-2">飞机、舰船动态监测</el-menu-item> -->
              <el-menu-item
                @click="saveNavState('/scientific/Aircraft_Systems')"
                index="/scientific/Aircraft_Systems"
              >
                <span slot="title">机载影像边缘实时处理系统</span>
              </el-menu-item>
              <!-- <el-menu-item index="1-2-3">灾害动态监测系统</el-menu-item> -->
              <el-menu-item
                @click="saveNavState('/scientific/vehicle_vision_system')"
                index="/scientific/vehicle_vision_system"
              >
                <span slot="title">车载视觉实时处理系统</span>
              </el-menu-item>
              <!-- <el-menu-item index="1-2-4">三维违章建筑物监测系统</el-menu-item> -->
              <!-- </el-submenu> -->
              <el-menu-item
                @click="saveNavState('/scientific/d3_GIS')"
                index="/scientific/d3_GIS"
              >
                <template slot="title">三维GIS平台</template>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/Big_data')"
                index="/scientific/Big_data"
              >
                <template slot="title">时空大数据平台</template>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <!-- <i class="el-icon-share"></i> -->
                <span style="font-weight: bolder; color: #076498">应用系统</span>
              </template>
              <el-menu-item
                @click="saveNavState('/scientific/Resource_apply')"
                index="/scientific/Resource_apply"
              >
                <template slot="title">自然灾害遥感监测评估系统</template>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/Disaster_apply')"
                index="/scientific/Disaster_apply"
              >
                <template slot="title">地质灾害监测预警系统</template>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/Resource_updata')"
                index="/scientific/Resource_updata"
              >
                <template slot="title">遥感自然资源地理要素更新系统</template>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/Emergency_apply')"
                index="/scientific/Emergency_apply"
              >
                <template slot="title">空天地一体遥感应急指挥系统</template>
              </el-menu-item>
              <el-menu-item
                @click="saveNavState('/scientific/Illegal_building')"
                index="/scientific/Illegal_building"
              >
                <template slot="title">城市违章建筑物遥感检测系统</template>
              </el-menu-item>

              <el-menu-item
                @click="saveNavState('/scientific/Smart_city')"
                index="/scientific/Smart_city"
              >
                <template slot="title">智慧城市应用</template>
              </el-menu-item>

              <el-menu-item
                @click="saveNavState('/scientific/Biodiversity')"
                index="/scientific/Biodiversity"
              >
                <template slot="title">遥感生物多样性监测系统</template>
              </el-menu-item>

              <el-menu-item
                @click="saveNavState('/scientific/NLP')"
                index="/scientific/NLP"
              >
                <template slot="title">自然资源语言/语音智能交互系统</template>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "/scientific/Target_retrieval", //默认
      openeds: ["1", "2"],
      uniqueOpened: false,
    };
  },

  created() {
    this.activeIndex = window.sessionStorage.getItem("scientificactivePath");
    if (this.activeIndex !== null) {
      this.saveNavState(this.activeIndex);
    } else {
      this.saveNavState("/scientific/Target_retrieval");
    }
  },
  methods: {
    saveNavState(activePath) {
      window.sessionStorage.setItem("scientificactivePath", activePath);
      this.activeIndex = activePath;
      this.$router.push(activePath);
    },
  },
  // created() {
  //   this.activeIndex = window.sessionStorage.getItem("activePath");
  //   this.saveNavState(this.activeIndex);
  // },
  // methods: {
  //   saveNavState(activePath) {
  //     console.log(this);
  //     window.sessionStorage.setItem("activePath", activePath);
  //     this.activeIndex = activePath;
  //   },
  // },
};
</script>

<style lang="less" scoped>
#scientific {
  margin: 0 auto;
  .el-menu-item{
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
